import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as EventEmitter from 'events';
import { createStore } from '../store';
import { AuthenticationContext } from './context';
import { deepMerge, getPreparedPreloadedState } from './utils';
export function createContext(options, preloadedState) {
  var context = _extends({}, (_objectDestructuringEmpty(options), options));
  var config = context.config;
  var emitter = new EventEmitter();
  var preparedPreloadedState = getPreparedPreloadedState(config);
  var getPreloadedState = deepMerge(preparedPreloadedState, preloadedState);
  var store = createStore({
    context: _objectSpread(_objectSpread({}, context), {}, {
      emitter: emitter
    }),
    preloadedState: getPreloadedState
  });
  return new AuthenticationContext(store, emitter);
}